module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": '¿Como administrar el dinero?',
      "videoEmbed": "ADMINISTRACIONDINERO16ComoAdministrarDinero(ant47).mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "xs12": "",
      "sm3": "",
      "text-xs-right": "",
      "mt-5": "",
      "hidden-xs-only": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 120,
      "imaSrc": "design/red-arrow",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm8": "",
      "mt-5": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "La mejor manera de administrar el dinero y tener siempre un flujo de efectivo positivo es realizar un presupuesto.",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("La mejor manera de administrar "), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("el dinero y tener siempre un flujo de efectivo positivo ")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v("es realizar un presupuesto.")])], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "text-xs-center": "",
      "mt-2": "",
      "hidden-xs-only": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 386,
      "imaSrc": "design/texture",
      "imaAlt": ""
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55b9fe40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-16.vue
// module id = 986
// module chunks = 1